<template>
  <div>analyze</div>
</template>

<script>
export default {
  name: "TheInvestmentsAnalytics"
}
</script>

<style scoped>

</style>